import { useState } from 'react';
import type { SearchFormValues } from '../schema';

export interface SearchParams {
  [key: string]: BanHangValue;
}

export interface PrintTemplateData {
  [key: string]: BanHangValue;
}

export interface UseDialogStateReturn {
  initialSearchDialogOpen: boolean;
  editPrintTemplateDialogOpen: boolean;
  showTable: boolean;
  searchParams: SearchFormValues | null;
  handleInitialSearchClose: () => void;
  handleInitialSearch: (
    formData: BanHangPayload,
    getReport: (params: BanHangTableParams) => Promise<void>
  ) => Promise<void>;
  handleSearchClick: () => void;
  handleEditPrintTemplateClick: () => void;
  handleClosePrintTemplateDialog: () => void;
  handleSavePrintTemplate: (data: PrintTemplateData) => void;
  setShowTable: (show: boolean) => void;
  setSearchParams: (params: SearchFormValues) => void;
}

export function useDialogState(): UseDialogStateReturn {
  const [initialSearchDialogOpen, setInitialSearchDialogOpen] = useState(true);
  const [editPrintTemplateDialogOpen, setEditPrintTemplateDialogOpen] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [searchParams, setSearchParams] = useState<SearchFormValues | null>(null);

  const handleInitialSearchClose = () => {
    setInitialSearchDialogOpen(false);
  };

  const handleInitialSearch = async (
    formData: BanHangPayload,
    getReport: (params: BanHangTableParams) => Promise<void>
  ) => {
    setSearchParams(formData as SearchFormValues);
    setShowTable(true);
    setInitialSearchDialogOpen(false);
    await getReport(formData);
  };

  const handleSearchClick = () => {
    setInitialSearchDialogOpen(true);
  };

  const handleEditPrintTemplateClick = () => {
    setEditPrintTemplateDialogOpen(true);
  };

  const handleClosePrintTemplateDialog = () => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleSavePrintTemplate = (data: PrintTemplateData) => {
    console.log('Print template saved:', data);
    setEditPrintTemplateDialogOpen(false);
  };

  return {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,

    handleInitialSearchClose,
    handleInitialSearch,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    setShowTable,
    setSearchParams
  };
}
